import { themes } from 'kb-shared';
import { History } from 'history';
import React from 'react';
import styled from 'styled-components';
import { benefitIcon } from '../../assets/icons';

type Props = {
  history: History;
  description?: string;
};

const BenefitsWidget = ({ description }: Props) => {
  return (
    <Container>
      <BenefitsIcon src={benefitIcon} alt={'icon'} />
      <Text>My Benefit Coverage</Text>
      <SubTitle>Your coverage includes:</SubTitle>
      <BenefitsWrapper>
        <BenefitBar>
          <SubText>{description}</SubText>
        </BenefitBar>
      </BenefitsWrapper>
    </Container>
  );
};

export default BenefitsWidget;

const BenefitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items; center;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  border: solid 4px ${themes.colors.KBNight};
  background-color: ${themes.colors.pink};
  padding: 20px 0px;
  min-height: 100%;
`;

const Text = styled.div`
  ${({ theme }) => theme.fonts.DomaineDisplay};
  font-size: 24px;
  text-align: center;
  color: ${themes.colors.KBNight};
  margin-top: 10px;
`;

const SubTitle = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${themes.colors.KBNight};
  padding: 0px 25px 20px 25px;
  margin-top: 12px;
  font-weight: bold;
`;

const SubText = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${themes.colors.KBNight};
  padding: 0px 25px;
`;

const BenefitBar = styled.div`
  margin-left: 20px;
  border-left: 2px solid #fff;
  border-radius: 1px;
`;

const BenefitsIcon = styled.img`
  width: 81px;
  height: 75px;
  object-fit: contain;
`;
